import { SchemaWithClient } from '../types/SchemaWithClient';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { GroupClient } from '../services/GroupClient';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';

export const groupForServiceReservationAddNew: SchemaWithClient<any> = {
  name: 'Group',
  pluralName: 'Groups',
  columns: {
    name: {
      name: 'Group Name',
      required: false,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      style: {
        background: '#256861',
        color: '#fff',
      },
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new GroupClient(),
  viewTable: 'groups',
  isViewTable: true,
};
